angular.module('app').controller('PriceListCtrl', function($scope, $controller, $mdToast, appUtils, $rootScope) {
    "ngInject";

    var main = this;
    main.name = 'price_list';
    main.defaults = {
        'categories': [
            {'name': 'A la Carte Menu', 'items': []},
            {'name': 'Digital Packages', 'items': []},
            {'name': 'Print Packages', 'items': []},
        ]
    };

    main.defaultAdd = function() {
        return {
            'price_model': 'Fixed Price',
            'ranges': []
        };
    };

    main.toAdd = main.defaultAdd();
    main.copyCollections = [
        {'name': 'categories', 'key': 'id'}
    ];

    $scope.$on('model-copied', function() {
        if(!$rootScope.is_superadmin) {
            main.item.shared = false;
        }

        main.item.categories.forEach(function(category) {
            category.items.forEach(function(item) {
                delete item.id;
            });
        });
    });

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.addCategory = function() {
        main.item.categories.push({ 'name': main.newCatName, 'items': [] });
        main.newCatName = '';
        var message = "Added Catgegory";
        var alert = $mdToast.simple().textContent(message);
        $mdToast.show(alert);
    };

    main.addProduct = function() {
        var pListItem = {
            'price': main.toAdd.price,
            'product_id': main.toAdd.product.id,
            'product': main.toAdd.product,
            'price_model': main.toAdd.price_model,
            'ranges': main.toAdd.price_model == 'Ranged Pricing' ? [{}] : []
        };
        main.toAdd.category.items.push(pListItem);

        main.toAdd = main.defaultAdd();

        var message = "Added Product";
        var alert = $mdToast.simple().textContent(message);
        $mdToast.show(alert);
    };

    main.removeItem = function(item, cat) {
        appUtils.remove(item, 'product_id', cat.items);
    };

    main.removeRange = function(item, range) {
        if (item.ranges.length <= 1) return;
        item.ranges = item.ranges.filter(function(existing) {
            return existing !== range;
        });
        // Card 373 provides dirty tracking; this editor also runs without it.
        if (main.markDirty) main.markDirty();
    };

    main.productSearch = function(text) {
        var params = appUtils.emptyQuery();
        // Filter out products where class_photos_only is true
        // Include products where class_photos_only is false OR null (for backwards compatibility)
        params.q.filters.push({
            'or': [
                {'name': 'class_photos_only', 'op': 'eq', 'val': false},
                {'name': 'class_photos_only', 'op': 'is_null'}
            ]
        });
        return appUtils.search('product', text, params);
    };
});
